import React from 'react'
import DatePicker from 'react-datepicker';


const CommonCurrentDatePicker = ({ setFromDate, setToDate, fromDate, toDate }) => {
    // console.log('fromDate', fromDate)
    return (
        <div>
            <div className='d-flex ac-js my-4 gap-3' >
                <p className="f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 primary">
                    From Date :
                </p>
                <div className="">
                    <DatePicker
                        selected={fromDate}
                        onChange={(date) => {
                            setFromDate(date);

                        }}
                        dateFormat="dd-MM-yyyy"
                        className="input-pop-new ps-2 w-100"
                        placeholderText="From Date"
                        type='date'
                        maxDate={new Date()}
                    />
                </div>
                <p className="f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 primary">
                    To Date :
                </p>
                <div className=''>
                    <DatePicker
                        selected={toDate}
                        onChange={(date) => {

                            setToDate(date);

                        }}

                        dateFormat="dd-MM-yyyy"
                        className="input-pop-new ps-2 w-100"
                        placeholderText="To Date"
                        type='date'
                        maxDate={new Date()}
                    />
                </div>
            </div>
        </div>
    )
}

export default CommonCurrentDatePicker